import { http } from "@/libs/http";
import type { PlatformDocs } from "./types";

export const getPlatformDocs = () =>
  http.get<PlatformDocs>("/dev/v1/docs/platform");

export const downloadPlatformSkill = async () => {
  const blob = await http.get<Blob>("/dev/v1/docs/platform/skill", {
    responseType: "blob",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "platform-auth-skill.zip";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
